import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap, catchError, of } from 'rxjs';

import { environment } from "../../environments/environment"
import { mockResponseExact } from './mockResponse-exact';
import { mockResponseSemantic } from './mockResponse-semantic';
import { mockResponseString } from './mockResponse-string';

/*
	https://public-api.gbd.globaldb.prd.web1.wipo.int/gs-assistant/exactSearch?term=sushi

	exactSearch can be replace with :

	exactSearch
	semanticSearch
	stringSearch
*/

@Injectable({
	providedIn: 'root'
})
export class SearchService {

	public isLoading: boolean = false

	constructor(private http: HttpClient) { }

	public callSearch(params: any): Observable<any> {
		const l = `ss.callSearch() - `
		// console.log(`${l}received params=`, deepClone(params))

		params.term = encodeURIComponent(params.term);

		let urlSegments = [`${environment.apiURL}/${params.searchType}?query=${params.term}`]

		for(let word of ["inputLang","outputLang","display"]){
			if(params[word]) urlSegments.push(`${word}=${params[word]}`);
		}

		if(params.offices?.length){
			const joinedOffices = params.offices.map(o => o.value).join(",");
			urlSegments.push(`offices=${joinedOffices}`)
		}

		const url = urlSegments.join("&")
		this.isLoading = true

		// console.log(`${l}Returning http.get('${url}')`)

		let headers;

		if(environment["apiUser"]){
			headers = new HttpHeaders({
				"Authorization": `Basic ${btoa(environment["apiUser"] + ":" + environment["apiPwd"])}`,
			})
		} else {
			headers = new HttpHeaders({
				"Authorization": "Bearer 37538A20-D9B3-4D03-BDDA-4C310DAC2A30"
			})
		}

		return this.http.get(url, {headers, responseType: 'text'}).pipe(
			catchError(error => {
				console.warn(`${l}HTTP request failed:`, error);
				
				// Only allow mock data in localhost or development environments
				if (environment.env === 'awsProd' || environment.env === 'awsacc' || 
				    (environment as any).production === true || 
				    (!window.location.hostname.includes('localhost') && !environment.env.includes('localhost') && !environment.apiURL.includes('awsdev'))) {
					console.error(`${l}Production environment detected (env: ${environment.env}) - mock data fallback is forbidden`);
					throw error; // Re-throw the error in production
				}
				
				console.warn(`${l}Development environment detected - falling back to mock data`);
				
				// Return mock data based on search type (only in development)
				let mockData;
				switch(params.searchType) {
					case 'exactSearch':
						mockData = mockResponseExact;
						break;
					case 'semanticSearch':
						mockData = mockResponseSemantic;
						break;
					case 'stringSearch':
						mockData = mockResponseString;
						break;
					default:
						mockData = mockResponseSemantic; // default fallback
				}
				
				// Convert mock data to string format to match the expected response format
				return of(JSON.stringify(mockData));
			})
		);
	}
}
